<template>
  <div class="groups">

    <!-- image -->
    <v-card max-width="500" class="mx-auto">
      <v-card-actions>
        <v-btn text color="blue-grey" @click="goToMyPage">
          <v-icon>mdi-arrow-left</v-icon>
          <span class="ml-2">내 페이지 가기</span>
        </v-btn>
      </v-card-actions>
      <v-img dark height="200px" src="/binoculars.jpg"></v-img>
      
      <!-- component -->
      <CreatingGroup v-if="user" />
    </v-card>
    
    <v-container class="mt-5" fluid v-if="groups">

      <!-- text field for Search  -->
      <div class="search mx-auto">
        <v-text-field outlined label="Search" append-icon="search" v-model="search" class="mt-5">
        </v-text-field>
      </div>
      
      <!-- groups brought back from db -->
      <v-card max-width="500" class="mx-auto">
        <v-list two-line subheader>
          <v-subheader>모임들({{ localGroups.length }})</v-subheader>

          <v-list-item v-for="group in filteredGroups" :key="group.id" @click="goToGroup(group.id)">
            <v-list-item-avatar>
              <v-img :src="group.imgURL"></v-img>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title v-text="group.name"></v-list-item-title>
              <v-list-item-subtitle v-text="group.region"></v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content>
              <v-list-item-title v-text="group.creator.name"></v-list-item-title>
              <v-list-item-subtitle v-text="group.creator.alias"></v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <span v-text="group.members.length"></span>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
    </v-container>
  </div>

</template>

<script>
import CreatingGroup from '@/components/CreatingGroup'
import db from '@/fb'
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  name: 'Groups',
  components: { CreatingGroup },
  data: () => ({
    groups: [],
    search: '',
    user: false
  }),
  methods: {
    goToGroup(id) {
      this.$router.push({ name: 'Group', params: { group_id: id} });
    },
    goToMyPage(){
      this.$router.push({ name: 'MyPage' })
    }
  },
  computed: {
    localGroups(){
      return this.groups.filter(group => {
        return group.name != 'Open League'
      })
    },
    filteredGroups(){
      return this.localGroups.filter(group => {
        return group.name.toLowerCase().match(this.search) || 
          group.region.toLowerCase().match(this.search) ||
          group.creator.name.toLowerCase().match(this.search) ||
          group.creator.alias.toLowerCase().match(this.search)
      })
    }
  },
  created(){

    // get all the groups
    db.collection('groups').orderBy('timeStamp').onSnapshot(snapshot => {
      let changes = snapshot.docChanges();
      changes.forEach(change => {          
        if(change.type == 'added'){
          this.groups.unshift({
            ...change.doc.data(),
            id: change.doc.id
          });
        } else if(change.type == 'removed'){
          this.groups = this.groups.filter(game => {
            return game.id != change.doc.id;
          })
        }
      })
    })

    // check if there is a user
    let user = firebase.auth().currentUser;
    if(user){
      this.user = true
    } else {
      this.user = false
    }
  }
};
</script>

<style>

div.search {
  max-width: 500px;
}

</style>